import Alpine from 'alpinejs';

Alpine.data('menuComponent', () => ({
  activeSection: '',
  inter: '',
  menuOffset: 0,

  init() {
    const navScroll = document.querySelector('.menu_nav-scroll');
    if (navScroll) {
      this.menuOffset = parseFloat(getComputedStyle(navScroll).paddingLeft) || 0;
    }
  },

  highlightActive(e) {
    const target = e.currentTarget.getAttribute('href').split('#')[1];
    this.activeSection = target;
    this.scrollToHeading(target);

    const sectionEl = document.querySelector('.menu_section div#' + target);
    if (!sectionEl) return;
    const headingEl = sectionEl.querySelector('.menu_heading');
    const top = sectionEl.offsetTop - (headingEl ? headingEl.clientHeight : 0);

    window.scrollTo({
      top,
      left: 0,
      behavior: 'smooth'
    });
  },

  scrollToHeading(el) {
    const navScroll = document.querySelector('.menu_nav-scroll');
    const link = document.querySelector('.menu_nav-scroll a[href="#' + el + '"]');
    if (!navScroll || !link) return;
    navScroll.scrollTo({
      left: link.offsetLeft - this.menuOffset,
      behavior: 'smooth'
    });
  },

  highlightNav(el) {
    this.activeSection = el;
    this.scrollToHeading(el);
  }
}));
